'use strict';

import template from './join_options.html';

var LOCAL_STORAGE_KEY = 'joinOption';
var BUTTON_CONFIG = {
  fb: {
    cssClass: 'Button--fb',
    iconCssClass: 'Icon-fb',
    name: 'fb',
    displayName: 'Facebook',
    social: true
  },
  vk: {
    cssClass: 'Button--vk',
    iconCssClass: 'Icon-vk',
    name: 'vk',
    displayName: 'VKontakte',
    social: true
  },
  email: {
    cssClass: 'Button--email Button--orange2',
    iconCssClass: 'Icon-envelopeInverted',
    name: 'email',
    displayName: 'your email'
  }
};
var controller = [
  'social',
  'localStorage',

  function (social, localStorage) {
    var mainOption = localStorage.get(LOCAL_STORAGE_KEY);

    if (!BUTTON_CONFIG[mainOption]) {
      mainOption = social.getUserSocialNetwork();
    }

    this.mainButton = BUTTON_CONFIG[mainOption];
    this.otherButtons = Object.keys(BUTTON_CONFIG)
      .filter(function (optionName) {
        return optionName !== mainOption;
      })
      .map(function (optionName) {
        return BUTTON_CONFIG[optionName];
      });

    this.selectOption = function (option) {
      this.done({
        option: option.name
      });

      // Save last selected option
      localStorage.set(LOCAL_STORAGE_KEY, option.name);
    };
  }
];
var saJoinOptions = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        done: '&'
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saJoinOptions;



// WEBPACK FOOTER //
// ./app/src/modules/join/join_options.component.js